/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AssociatedClientsForResource } from './AssociatedClientsForResource';
import {
	AssociatedClientsForResourceFromJSON,
	AssociatedClientsForResourceFromJSONTyped,
	AssociatedClientsForResourceToJSON,
} from './AssociatedClientsForResource';

/**
 * A payload containing client entities associated with resourceIds
 * @export
 * @interface AssociatedClientsForResourcesResponse
 */
export interface AssociatedClientsForResourcesResponse {
	/**
	 *
	 * @type {Array<AssociatedClientsForResource>}
	 * @memberof AssociatedClientsForResourcesResponse
	 */
	associatedClientsForResources?: Array<AssociatedClientsForResource>;
}

/**
 * Check if a given object implements the AssociatedClientsForResourcesResponse interface.
 */
export function instanceOfAssociatedClientsForResourcesResponse(value: object): boolean {
	let isInstance = true;

	return isInstance;
}

export function AssociatedClientsForResourcesResponseFromJSON(
	json: any
): AssociatedClientsForResourcesResponse {
	return AssociatedClientsForResourcesResponseFromJSONTyped(json, false);
}

export function AssociatedClientsForResourcesResponseFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): AssociatedClientsForResourcesResponse {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		associatedClientsForResources: !exists(json, 'associatedClientsForResources')
			? undefined
			: (json['associatedClientsForResources'] as Array<any>).map(
					AssociatedClientsForResourceFromJSON
			  ),
	};
}

export function AssociatedClientsForResourcesResponseToJSON(
	value?: AssociatedClientsForResourcesResponse | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		associatedClientsForResources:
			value.associatedClientsForResources === undefined
				? undefined
				: (value.associatedClientsForResources as Array<any>).map(
						AssociatedClientsForResourceToJSON
				  ),
	};
}
